import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        color: Theme.primaryLinkColor,
        textDecorationLine: 'underline'
    }
};

export default StyleSheet.create(baseStyles);
